import React, { useEffect, useState } from 'react';
import { Text, Paper, Colors } from 'library';
import { Grid } from '@material-ui/core';
import { emptyProvider, PastProvider } from './models';
import { useUserContext } from 'UserContext';
import ReferProvider from './ReferProvider';
import { useHistory } from 'react-router-dom';
import { Provider } from 'models';
import { getCopy } from './referralCopy';
import ReferralMethodChoice from './ReferralMethodChoice';
import InviteProviderToTandem from './InviteProviderToTandem';
import { StatsModel } from '../Community';
import ReferralStats from './ReferralStats';

interface IProps {
    referralContext: string;
    referralStats: StatsModel;
}

const ReferralActions = ({ referralContext, referralStats }: IProps) => {
    const history = useHistory<{ sitter?: Provider }>();
    const { user } = useUserContext();
    const baseUrl = `${window.location.origin}/?referral=`;
    const [url, setUrl] = useState(`${baseUrl}${user?.referral_code}`);
    const [referredProvider, setReferredProvider] = useState<PastProvider>(emptyProvider);
    const [message, setMessage] = useState(getCopy(referredProvider));

    useEffect(() => {
        setMessage(getCopy(referredProvider));
    }, [referredProvider]);

    useEffect(() => {
        let sitter = history.location.state?.sitter;
        if (sitter) {
            setReferredProvider({
                first_name: sitter.user.first_name,
                last_name: sitter.user.last_name,
                id: sitter.user.id,
                babysitter_id: sitter.id,
            });
        }
    }, []);

    useEffect(() => {
        let sitterCode = referredProvider?.id > 0 ? `&sitter=${referredProvider.id}` : '';
        if (sitterCode && referredProvider) {
            setUrl(
                `${window.location.origin}/provider/${referredProvider.id.toString()}/?referral=${
                    user?.referral_code
                }${sitterCode}`,
            );
        } else {
            setUrl(`${baseUrl}${user?.referral_code}${sitterCode}`);
        }
    }, [baseUrl, referredProvider, user]);

    return (
        <>
            <ReferralStats referralStats={referralStats} />
            <Paper>
                <Grid container direction="column">
                    <Text variant="h1" bold>
                        {referredProvider?.id > 0
                            ? `Refer ${referredProvider.first_name} to a friend and you'll each get a $20 discount!`
                            : '$20 for you, $20 for a friend!'}
                    </Text>
                    <Text variant="body1" color={Colors.darkGrey} textStyle={{ marginTop: 6, marginBottom: 30 }}>
                        When a friend who needs care uses your link or code {user?.referral_code} to sign up, you each
                        get $20 off your next job.
                    </Text>
                    <ReferProvider referredProvider={referredProvider} updateReferredProvider={setReferredProvider} />
                    <ReferralMethodChoice
                        message={message}
                        referredProvider={referredProvider}
                        referralContext={referralContext}
                        setMessage={setMessage}
                        url={url}
                    />
                    <InviteProviderToTandem referralContext={`${referralContext}: Invite Provider to Tandem`} />
                </Grid>
            </Paper>
        </>
    );
};

export default ReferralActions;
